import React from 'react';
import { useTranslation } from 'react-i18next';

const SelectBulkAction = ({ options, listCheckboxIds }) => {
  const { t, i18n } = useTranslation();

  const requestAction = (e) => {
    const item = options.find((el) => el.title === e.target.value);
    if (item) {
      item.action(listCheckboxIds);
    }
  };

  return (
    <div>
      <select class="form-control" onClick={requestAction}>
        <option value="">{t('table.bulk-actions')}</option>
        {options.map((el) => (
          <option>{el.title}</option>
        ))}
      </select>
    </div>
  );
};

export default SelectBulkAction;
